import { render } from "./pay-me-flow.vue?vue&type=template&id=5b497ccc&scoped=true"
import script from "./pay-me-flow.vue?vue&type=script&lang=js"
export * from "./pay-me-flow.vue?vue&type=script&lang=js"

import "./pay-me-flow.vue?vue&type=style&index=0&id=5b497ccc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b497ccc"]])

export default __exports__